export default __webpack_public_path__ + "static/media/error-404.666b34e1.svg";